import { useApolloClient } from "@apollo/client";
import {
  PortalExportDocument,
  PortalExportQuery,
  PortalMyExportDocument,
  PortalMyExportQuery,
} from "@dashboard/graphql";
import { Button } from "@saleor/macaw-ui-next";
import { useState } from "react";
import { useIntl } from "react-intl";

import { portalMessages as m } from "./messages";
import { today } from "./utils";

/** Downloads a verifiable ZIP (records, sign-offs, seals, verify.py) for the
 * last 12 months: the colaborador's own, or (gerência) someone's. */
export const ExportButton = ({ userId }: { userId?: string }) => {
  const intl = useIntl();
  const client = useApolloClient();
  const [loading, setLoading] = useState(false);
  const end = today();
  const start = `${Number(end.slice(0, 4)) - 1}${end.slice(4)}`;

  const handleClick = async () => {
    setLoading(true);

    try {
      const url = userId
        ? (
            await client.query<PortalExportQuery>({
              query: PortalExportDocument,
              variables: { start, end, userId },
              fetchPolicy: "network-only",
            })
          ).data?.exportUrl
        : (
            await client.query<PortalMyExportQuery>({
              query: PortalMyExportDocument,
              variables: { start, end },
              fetchPolicy: "network-only",
            })
          ).data?.myExportUrl;

      if (url) {
        window.location.assign(url);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="tertiary"
      size="small"
      disabled={loading}
      onClick={handleClick}
      title={intl.formatMessage(m.exportHint)}
    >
      {intl.formatMessage(m.exportRecord)}
    </Button>
  );
};
